import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler.js";
import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_funnel_layover_price_airport_filter_web",
    defaultStage: 1,
    stages: {
        main: 1,
        desktop: 2,
        mobile: 3,
        meta: 4,
        direct: 5,
        longhaul: 6,
        weekend: 7,
        families: 8,
        multistop: 9
    },
    goals: {
        layover: 1,
        price: 2,
        airports: 3,
        reset: 4,
        deselect: 5
    }
});
export const useTrackLayoverPriceAirportFilterWeb = () => {
    const { isDesktop, isMobile, isMeta, isDirect, isLongHaul, isWeekendStay, isFamily, isMultiStop } = useProfiler();
    return useCallback(() => {
        const variant = utils.trackWithDefaultStage();
        isDesktop() && utils.stages.desktop();
        isMobile() && utils.stages.mobile();
        isMeta() && utils.stages.meta();
        isDirect() && utils.stages.direct();
        isLongHaul() && utils.stages.longhaul();
        isWeekendStay() && utils.stages.weekend();
        isFamily() && utils.stages.families();
        isMultiStop() && utils.stages.multistop();
        return !!variant;
    }, [isDesktop, isMobile, isMeta, isDirect, isLongHaul, isWeekendStay, isFamily, isMultiStop]);
};
export default utils;
